import React, { useEffect, useState } from "react";
import { backendApi } from "../../api/apiService";
import ReactSelect from "react-select";
import ReactQuill from "react-quill";
import { Buffer } from "buffer";
import "react-quill/dist/quill.snow.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { awsConfig } from "../../config";
import AWS from "aws-sdk";
import html2pdf from 'html2pdf.js';
import jsPDF from 'jspdf';
import { setAwsConfigData } from "../../redux/reducers/masterDataSlice";
import moment from "moment";
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
function SendEmailComponent({closePopup, candidateDetails,resumeDetails,SelectedAttachement}) {
  const [awsConfigDataState, setAwsConfigDataState] = useState(awsConfig);
  const [toEmail, setToEmail] = useState(candidateDetails.email_id?candidateDetails.email_id:"");
  const [subject, setSubject] = useState("");
  const [convertedDataPdf,setConvertedDataPdf]=useState()
  var s3;
  const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, 3, 4, 5, 6] }, { font: [] }],
        [{ size: [] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["image"],
      ],
    },
  };
  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const base64Image = await convertImageToBase64(resumeDetails);
  //       if (base64Image) {
  //         setConvertedDataPdf(base64Image);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching or converting image:', error);
  //     }
  //   };

  //   fetchData();
  // }, [resumeDetails]);

  const convertHtmlToBase64Pdf = async (htmlContent) => {
  try {
    // Create an element to hold the HTML content
    const element = document.createElement('div');
    element.innerHTML = htmlContent;

    // Generate PDF using html2pdf.js
    const pdfOptions = {
      margin: 10,
      filename: 'converted_document.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
    };

    const pdfBlob = await html2pdf().from(element).set(pdfOptions).outputPdf();

    // Convert PDF blob to base64
 

    return pdfBlob;
  } catch (error) {
    console.error('Error converting HTML to base64 PDF:', error);
    return null;
  }
};
  
  const sendEmail = async () => {
    if (toEmail == "") {
      toast.warn("To Email Id", { containerId: "F" });
      return false;
    } else if (subject == "") {
      toast.warn("E-mail subject required", { containerId: "F" });
      return false;
    }
  
    try {
      const pdfBlob = await convertHtmlToBase64Pdf(resumeDetails);
      // console.log(pdfBlob, "pdfBlobpdfBlobpdfBlob");
        // return
      
      const bucketParams = {
        Bucket: awsConfigDataState.s3Bucket,
      };
  
      AWS.config.update({
        accessKeyId: awsConfigDataState.s3BucketAccessKey,
        secretAccessKey: awsConfigDataState.s3bucketSecretKey,
        region: "us-east-1",
      });
  
      const s3 = new AWS.S3({
        apiVersion: "2006-03-01",
        params: bucketParams,
      });
  
      const data = await s3
      .upload({
        Key: `${awsConfigDataState.s3BucketMainFolder}/${awsConfigDataState.s3BucketSubFolder}/${candidateDetails.full_name}.pdf`,
        // Key: `${candidateDetails.full_name}.pdf`,
        Body: pdfBlob,
        ACL: "public-read",
        ContentType: "application/pdf" // Corrected header name
      })
        .promise();
      // pictureUrl = data.Location;
      // console.log("PDF uploaded to S3:", pictureUrl);
      const postData={
        "functionName": "timeLine",
        "category": "offerLetterSave",
         "summary": "",
          "created_on": formatDate(),
           "attachments":[data.Location + ((SelectedAttachement.length>0) ? `,${SelectedAttachement.join(',')}` : '')],
           "candidate_id":candidateDetails.id
      }
      console.log(postData,"dddddddddddddddddddddddddddddddhhhhhhhhhhhhhhhhhhhhhrrrrrrrrrrrrrl");
      //  return
      const result = await backendApi(postData);
      if (result.success === "1") {
      const apiReq = {
        functionName: "sendEmailFunction",
        subject: subject,
        body: resumeDetails,  // Assuming you need pdfBlob here, not resumeDetails
        toEmail: toEmail,
        // toEmail: "vishnu.P@xilligence.com",
        email_cc: "",
        filename:["OfferLetter.pdf"],
        path:[data.Location + ((SelectedAttachement.length>0) ? `,${SelectedAttachement.join(',')}` : '')],
      };
  // 
      console.log(apiReq, "apiReqapiReq");
      const response = await backendApi(apiReq);
      console.log(response,"ttttttttttttttttttttttttttttttt");
      if (response.success === "1") {
        toast.success("Mail Sent Successfully", { containerId: "F" });
        setTimeout(() => {
          closePopup()
        }, 1000);
      } else {
        toast.error("Failed to sent E-Mail", { containerId: "F" });
      }
    }
    } catch (error) {
      console.error("Error during I request:", error);
    
    }
  };
    
  const formatDate = () => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    const formattedDate = new Date().toLocaleDateString('en-IN', options);
    return formattedDate;
}
// const generatePDF = async (resumeDetails) => {
//   console.log(resumeDetails,"resumeDetailsresumeDetailsresumeDetailsresumeDetails");
//   // Create a container element for the HTML content
//   const container = document.createElement('div');
//   container.innerHTML = resumeDetails;
//   document.body.appendChild(container); // Attach it to the DOM

//   try {
//     const canvas = await html2canvas(container, { scale: 2 });
//     const imgData = canvas.toDataURL('image/png');
//     const pdf = new jsPDF();
//     pdf.addImage(imgData, 'PNG', 0, 0);
//     const pdfBlob = pdf.output('blob');
//     return pdfBlob;
//   } catch (error) {
//     console.error("Error during PDF generation:", error); // Catch potential errors
//   } finally {
//     document.body.removeChild(container); // Remove the container element
//   }
// };
// const convertBase64ToBuffer = async (base64Url, format = "webp") => {
//   const base64Data = base64Url.split(",")[1];
//   const buffer = Buffer.from(base64Data, "base64");
//   return buffer;
// };
const generatePDF = async () => {
  // const htmlContent = document.getElementById('my-html-content').innerHTML; // Example

  const pdfOptions = {
    margin: 10,
    filename: 'my-document.pdf',
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
  };

  try {
    const pdfData = await html2pdf(resumeDetails, pdfOptions);
    console.log(pdfData,"pdfDatapdfDatapdfDatapdfDatapdfDatapdfDatapdfData");
    // const pdfBlob = new Blob([pdfData], { type: 'application/pdf' });
    // return pdfBlob
  
    // const pdfUrl = URL.createObjectURL(pdfBlob);
    // return pdfBlob
    // console.log(pdfUrl,"hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh");
  } catch (error) {
    console.error('Error during PDF generation:', error);
    // Handle the error appropriately
  }
};

// const generatePDF = async (resumeDetails) => {
//   const element = resumeDetails; // Replace 'pdfContent' with the id of your HTML content
//   if (!element) {
//     console.error('HTML element not found');
//     return;
//   }

//   const pdfOptions = {
//     margin: 10,
//     filename: 'converted_document.pdf',
//     image: { type: 'jpeg', quality: 0.98 },
//     html2canvas: { scale: 2 },
//     jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
//   };

//   try {
//     // Generate PDF as Blob
//     const pdfBlob = await html2pdf().from(element).set(pdfOptions).output();

//     // Now you can use the pdfBlob as needed (e.g., download or send to the server)
//     console.log('Generated PDF Blob:', pdfBlob);

//     return pdfBlob; // Return the Blob data
//   } catch (error) {
//     console.error('Error generating PDF:', error);
//     return null;
//   }
// };

  return (
    <div className="modal_parent">
       <ToastContainer
                enableMultiContainer
                containerId={"F"}
                position="bottom-right"
                autoClose={1500}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
      <div className="module_popup addPeople bfAddPeople">
        <div className="module_innerpopup module_bodypop">
          <div className="module_headdiv">
            <h4 className="popup_head">Send Email</h4>
            <div className="module_close"></div>
          </div>
          <div className="module_body" style={{ overflowX: "hidden" }}>
            <div className="row">
              {/* <div className="col-md-6">
                <div className="input-group input-group-outline mb-2 location_search">
                  <label htmlFor="" className="formLabel">
                    From
                  </label>
                  <div className="col-md-12 p-0 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter From Mail Id"
                      value={fromEmailId}
                      onChange={(e) => setFromEmailId(e.target.value)}
                    />
                  </div>
                </div>{" "}
              </div> */}
              <div className="col-md-6">
                {/* <div className="input-group input-group-outline mb-2 location_search">
                  <label htmlFor="" className="formLabel">
                    Select Opportunity :{" "}
                  </label>
                  <div className="col-md-12 p-0 position-relative">
                    <ReactSelect
                      type="text"
                      placeholder="Please Select an Opportunity"
                      options={opportunities}
                      onChange={setSelectedOpportunity}
                    //   value={contact}
                    //   readOnly={viewOnly}
                    //   onChange={(e) => setContact(e.target.value)}
                    />
                  </div>
                </div>{" "} */}
                <div className="input-group input-group-outline mb-2 location_search">
                  <label htmlFor="" className="formLabel">
                    To
                  </label>
                  <div className="col-md-12 p-0 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter To Mail Id"
                      value={toEmail}
                      onChange={(e) => setToEmail(e.target.value)}
                    />
                  </div>
                </div>{" "}
              </div>
              <div className="col-md-12">
                <div className="input-group input-group-outline mb-2 location_search">
                  <label htmlFor="" className="formLabel">
                    Subject
                  </label>
                  <div className="col-md-12 p-0 position-relative">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Mail Subject:"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                    //   value={officeContact}
                    //   onChange={(e) => setOfficeContact(e.target.value)}
                    //   readOnly={viewOnly}
                    />
                  </div>
                </div>{" "}
                {/* <div className="input-group input-group-outline mb-2 location_search">
                  <label htmlFor="" className="formLabel">
                    Mail Body:
                  </label>
                  <div className="col-md-12 p-0 position-relative">
                    <ReactQuill
                      theme="snow"
                      value={bodyValue}
                      onChange={(e) => setBodyValue(e)}
                      placeholder="Add Email Content"
                      modules={modules}
                    />
                  </div>
                </div>{" "} */}
              </div>
            </div>
          </div>

          <div className="childIssueses">
            <button
              className="btn btn-save"
              onClick={() => sendEmail()}
            //   onClick={isSubmitting ? null : createContact}
            //   disabled={isSubmitting}
            >
              Send
            </button>
            <button
              className="btn btn-cancel"
              onClick={closePopup}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SendEmailComponent;
